export default "__VITE_ASSET__$5U7x4kA9Ntl0gvpCto8pg__"